import * as $ from 'jquery';

export interface CollapsableOptions {
	container: string;
	item: string;
	trigger: string;
	target: string;
	defaultIndex?: number;
}
export default class CollapsableGroup {
	private element: JQuery;
	private selector_target: string;
	private selector_trigger: string;
	private defaultIndex: number;

	constructor(options: CollapsableOptions) {
		this.element = $(options.container);

		if (!this.element) { return };
		this.selector_trigger = options.trigger;
		this.selector_target = options.target;
		this.defaultIndex = options.defaultIndex || 0;

		this.setupEventHandlers();
		this.element.addClass('collapsable');

		$.when( this.collapseAll() ).done(() => {
			this.expandDefault();
		});
	}
	private collapseAll() {
		this.element.find(this.selector_target).slideUp(0);
	}
	private expandDefault() {
		this.toggleItem(this.element.find(this.selector_trigger).get(this.defaultIndex));
	}
	private toggleItem(triggerElement: Element, force?: boolean): void {
		const $element = $(triggerElement);
		const isOpen = $element.parent().hasClass('target');

		if (isOpen) {
			$element.parent().removeClass('target');
			$element.next().stop(true).slideUp();
		} else {
			$element.parent().addClass('target');
			$element.next().stop(true).slideDown();
		}
	}
	private setupEventHandlers(): void {
		this.element.on('click', this.selector_trigger, (event: JQueryMouseEventObject) => {
			event.preventDefault();
			if (!!event.currentTarget.parentElement.id){
				history.replaceState(undefined, undefined, location.pathname + "#" + event.currentTarget.parentElement.id);
			}
			this.toggleItem(event.currentTarget);
		});
	}
}
